<template>
  <UnSwitcherNew
    :swKey="hasICMConverter ? 'sw_ev_icm_converter' : 'sw_ev_converter'"
    tstPrefix="ev_converter"
    :hasOpener="false"
    @click="handleClick"
  >
    <template #menu_after="v">
      <div class="bt-grey my-1"></div>
      <div
        v-if="hasICMConverter"
        class="gw_btn gw_btn_text z-index_0 gw_btn_small clr-grey text-small f-justify-start bt-grey"
        style="--padding: 0.5rem"
        @click="
          v.methods.toggleOpen(false),
            $store.dispatch('router_set_dialogs', 'ev-converter-help-dialog')
        "
      >
        <i class="mdi mdi-help-circle-outline mr-1 text-medium" />
        {{ $t('common.help') }}
      </div>
      <div
        v-if="hasICMConverter"
        class="bt-grey my-1"
      ></div>

      <div
        class="gw_btn no-events gw_btn_text gw_btn_small clr-grey text-medium f-justify-start bt-grey"
        style="--padding: 0.375rem"
      >
        <span class="keyboardkey_key">
          {{ $store.getters.hotkeys.switch_ev_pot.displayCombination }}
        </span>
        <span
          class="keyboardkey_note"
          v-html="$t('hotkeys.study.to_toggle_grouping')"
        ></span>
      </div>
    </template>
  </UnSwitcherNew>
</template>

<script>
import UnSwitcherNew from '@/components/Switchers/UnSwitcher_new'

export default {
  name: 'StudyEvConverterSwitcher',
  components: {
    UnSwitcherNew,
  },
  props: {
    hasICMConverter: Boolean,
  },
  methods: {
    handleClick(item) {
      const payload = {
        [this.hasICMConverter ? 'showEvIcmIn' : 'showEvIn']: item.payload,
      }
      this.$store.dispatch('userSettings', payload)
    },
  },
}
</script>
